import { useJWTokens } from 'contexts/JWTContext';
import useLoading from 'hooks/useLoading';
import useTitle from 'hooks/useTitle';
import * as Authentication from 'models/authentication';
import React, { FormEvent, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

interface LocationState {
  from: Location;
}
const defaultCredentials: Authentication.LoginModel = {
  email: '',
  password: '',
};
export const Login = () => {
  useTitle('DigiTach: Login', true);
  const [credentials, setCredentials] = useState(defaultCredentials);
  const [loading, setLoading] = useLoading(false);
  const [, setTokens] = useJWTokens();

  const navigate = useNavigate();
  const location = useLocation();

  const locationState = location.state
    ? (location.state as LocationState)
    : undefined;
  const from = locationState?.from.pathname || '/';

  const handleControlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    switch (event.target.name) {
      case 'email':
        return setCredentials((prev) => ({ ...prev, email: value }));
      case 'password':
        return setCredentials((prev) => ({ ...prev, password: value }));
      default: throw new Error('Unexcepted input name');
    }
  };

  const login = async () => {
    setLoading(true);
    try {
      const response = await Authentication.api.Login(credentials);
      setLoading(false);
      setTokens(response.data, true);
      navigate(from, { replace: true });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const formSubmit = async (event: FormEvent) => {
    event.preventDefault();
    await login();
  };

  return (
    <div className="login-form">
      <h4>Administrator log ind</h4>
      <Form onSubmit={formSubmit}>
        <Form.Group>
          <Form.Label>Email</Form.Label>
          <Form.Control
            className="w-auto"
            type="email"
            name="email"
            autoComplete="email"
            placeholder="Indtast email addresse"
            value={credentials.email}
            onChange={handleControlChange}
          />
          <Form.Control.Feedback type="invalid">
            Forkert email
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
          <Form.Label>Adgangskode</Form.Label>
          <Form.Control
            className="w-auto"
            type="password"
            name="password"
            autoComplete="current-password"
            placeholder="Indtast adgangskode"
            value={credentials.password}
            onChange={handleControlChange}
          />
          <Form.Control.Feedback type="invalid">
            Forkert password
          </Form.Control.Feedback>
        </Form.Group>
        <Button variant="success" type="submit">
          Log ind
          {loading && <Spinner size="sm" animation="border" />}
        </Button>
      </Form>
    </div>
  );
};
export default Login;
